export const datetimeFormats = {
  'de-DE': {
    numeric: {
      year: 'numeric', month: '2-digit', day: '2-digit'
    },
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    }
  }
}